
import { IPropertyMapping } from '@/typings/import';
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import MappingHeaderSelect from '@/components/Importer/MappingHeaderSelect.vue';
@Component({
  components: {
    MappingHeaderSelect,
  },
})
export default class MappingPropertyInput extends Vue {
  private property: IPropertyMapping | null = null;

  @Prop({ default: '' }) private label: string;

  @Prop({ required: true }) private value: IPropertyMapping;
  @Watch('value', { immediate: true }) onValueChanged() {
    this.property = this.value;
  }  
}
